import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home/Home.vue'
import About from '../views/about/About.vue'
import Purchase from '../views/order/Purchase.vue'
import Grabbing from '../views/order/Grabbing.vue'
import My from '../views/user/My.vue'
import Login from '../views/auth/Login.vue'
import Register from '../views/auth/Register.vue'
import Recharge from '../views/my/Recharge.vue'
import Withdraw from '../views/my/Withdraw.vue'
import Kefu from '../views/support/Kefu.vue'
import RechargeRecord from '../views/my/RechargeRecord.vue'
import WithdrawRecord from '../views/my/WithdrawRecord.vue'
import Details from '../views/user/Details.vue'
import BindBank from '../views/user/BindBank.vue'
import BindUsdt from '../views/user/BindUsdt.vue'
import Team from '../views/user/Team.vue'
import ChangePassword from '../views/user/ChangePassword.vue'
import ChangeWithdrawPassword from '../views/user/ChangeWithdrawPassword.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'common.home'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'common.about',
      hideTabBar: true
    }
  },
  {
    path: '/purchase',
    name: 'Purchase',
    component: Purchase,
    meta: {
      title: 'common.purchase'
    }
  },
  {
    path: '/grabbing',
    name: 'Grabbing',
    component: Grabbing,
    meta: {
      title: 'common.grabbing',
      hideHeader: true
    }
  },
  {
    path: '/my',
    name: 'My',
    component: My,
    meta: {
      title: 'common.my'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'common.login',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: 'common.register',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: Recharge,
    meta: {
      title: 'recharge.title',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: Withdraw,
    meta: {
      title: 'withdraw.title',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/recharge-record',
    name: 'RechargeRecord',
    component: RechargeRecord,
    meta: {
      title: 'my.rechargeRecord',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/withdraw-record',
    name: 'WithdrawRecord',
    component: WithdrawRecord,
    meta: {
      title: 'my.withdrawRecord',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/details',
    name: 'Details',
    component: Details,
    meta: {
      title: 'my.accountDetails',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/bind-bank',
    name: 'BindBank',
    component: BindBank,
    meta: {
      title: 'bindBank.title',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/bind-usdt',
    name: 'BindUsdt',
    component: BindUsdt,
    meta: {
      title: 'bindUsdt.title',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
    meta: {
      title: 'team.title',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      title: 'my.changePassword',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/change-withdraw-password',
    name: 'ChangeWithdrawPassword',
    component: ChangeWithdrawPassword,
    meta: {
      title: 'my.changeWithdrawPassword',
      hideTabBar: true,
      hideHeader: true
    }
  },
  {
    path: '/kefu',
    name: 'Kefu',
    component: Kefu,
    meta: {
      title: 'common.kefu'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
